import { Text, type BasePoint, Editor } from 'slate';
import getNode from '@atlas/tool/box/slate/getNode';

export default function isValidPoint(editor: Editor, point: BasePoint): boolean {
    const { path, offset } = point;
    const node = getNode(editor, path);
    return Text.isText(node) && offset >= 0 && offset <= node.text.length;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isValidPoint', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
